import React, { FC, useCallback, useEffect, useRef, useState } from 'react';

import moment from 'moment';

import { AppLayoutTop } from 'components/appComponents';
import { Button, DataGrid, DateRangeBox, TabPanel } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import { FactoryDetail } from 'bus/factory/types';
import { useLazyGetMaterialBalanceByFactoryQuery } from 'bus/materialBalance/services';

import { BalanceArea, DetailTable, MainTable } from './components';
import { onExporting } from './utils';
import { exportGrids } from './utils/exportExcel';

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const MaterialBalance: FC = () => {
  const balanceDataGrid = useRef<DataGrid | null>(null);
  const detailDataGrid = useRef<DataGrid | null>(null);

  const [tabs, setTabs] = useState<Array<FactoryDetail>>([]);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [dateBegin, setDateBegin] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [dateEnd, setDateEnd] = useState(moment(new Date()).format('YYYY-MM-DD'));

  const [getMaterialBalanceByFactory, { isLoading, data }] = useLazyGetMaterialBalanceByFactoryQuery();

  const factoryDataStore = useCallback(async () => {
    const defaultFilter = ['parentId', '=', null];
    const tabsData = await $createDataSource('/v1/factory', 'id', {
      pageSize: 20,
      paginate: true,
      defaultFilter,
    }).load();
    setTabs(tabsData);
    getMaterialBalanceByFactory({ id: tabsData[selectedIndex].id, dateBegin, dateEnd });
  }, [dateBegin, dateEnd, getMaterialBalanceByFactory, selectedIndex]);

  useEffect(() => {
    factoryDataStore();
  }, [factoryDataStore]);

  const changeTabHandler = async (activeIndex: number) => {
    setSelectedIndex(activeIndex);
    await getMaterialBalanceByFactory({ id: tabs[activeIndex].id!, dateBegin, dateEnd });
  };

  const refreshHandler = async () => {
    await getMaterialBalanceByFactory({ id: tabs[selectedIndex].id!, dateBegin, dateEnd });
  };

  const dateBeginText = moment(dateBegin).format('DD.MM.YYYY');
  const dateEndText = moment(dateEnd).format('DD.MM.YYYY');

  const onExportingHandler = (e: any) => {
    onExporting(e, `${dateBeginText} - ${dateEndText}`);
  };

  const handleExportGrids = () => {
    exportGrids(balanceDataGrid.current?.instance, detailDataGrid.current?.instance);
  };

  const handleChangeDate = (dateRange: Array<string | Date | number>) => {
    dateRange[0] && setDateBegin(dateRange[0].toString());
    dateRange[1] && setDateEnd(dateRange[1].toString());
  };

  return (
    <div className="container-dev">
      <AppLayoutTop title="Остатки инерта">
        <Button icon="refresh" onClick={refreshHandler} />
        <Button icon="xlsxfile" onClick={handleExportGrids} />
      </AppLayoutTop>

      <TabPanel
        height="auto"
        dataSource={tabs}
        selectedIndex={selectedIndex}
        onOptionChanged={(e) => {
          if (e.name === 'selectedIndex') {
            changeTabHandler(e.value);
          }
        }}
        animationEnabled={false}
        itemTitleRender={itemTitleRender}
      />
      <div className="mt-2 d-flex justify-end">
        <DateRangeBox
          value={[dateBegin, dateEnd]}
          onValueChanged={(e) => handleChangeDate(e.value)}
          dateSerializationFormat="yyyy-MM-dd"
          stylingMode="underlined"
          useMaskBehavior
        />
      </div>
      {data && !isLoading && (
        <>
          <BalanceArea balanceArea={data.balanceArea} />
          <MainTable details={data.details} onExporting={onExportingHandler} ref={balanceDataGrid} />
          <div className="mt-2">
            <AppLayoutTop title="Итоги" />
          </div>
          <DetailTable totals={data.totals} onExporting={onExportingHandler} ref={detailDataGrid} />
        </>
      )}
    </div>
  );
};

export default MaterialBalance;
